import script from "./HandleSelector.vue?vue&type=script&setup=true&lang=js"
export * from "./HandleSelector.vue?vue&type=script&setup=true&lang=js"

import "./HandleSelector.vue?vue&type=style&index=0&id=445d7ef0&lang=scss"

const __exports__ = script;

export default __exports__